<div *ngIf="requestComments.length > 0; else noData"
    id="comment-history-container"
    class="comment-history-container d-flex flex-column mb-5"
>
    <div *ngFor="let comment of requestComments" class="comment-container d-flex flex-column p-3 gap-3">
        <div class="comment-header d-flex align-items-center gap-2">
            <app-user-badge [username]="comment.sender" fontSize="16px" [width]="35" [height]="35"></app-user-badge>
            <span HJSuppress class="fw-bold">{{comment.sender}}</span>
            <span HJSuppress class="date">{{comment.date | date:'medium'}}</span>
        </div>

        <div class="comment-body">
            <div HJSuppress class="comment-text">{{comment.comment}}</div>

            <div *ngIf="comment.documents?.length > 0" class="comment-documents d-flex align-items-center gap-2 mt-2">
                <i class="app-icon icon icon-attach icon-lg"></i>
                <span>{{'requests.details.category.commentAttachedFiles' | translate}}: </span>
                <ng-container *ngFor="let document of comment.documents; let isLast = last">
                    <button HJSuppress class="btn p-0 border-0 text-primary" (click)="downloadDocument(document)">
                        {{document.documentName}}
                    </button>
                    <ng-container *ngIf="!isLast">,</ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #noData>
    <div class="d-flex flex-column align-items-center gap-5 mb-5">
        <h2>{{'requests.details.category.noComments' | translate}}</h2>
        <no-records-placeholder></no-records-placeholder>
    </div>
</ng-template>

<div class="new-comment-container">
    <div class="new-comment-drop-upload-area" (drop)="uploadFileInStoreHandler($event, UPLOAD_MODE.DRAG_AND_DROP)">
        <textarea
            [(ngModel)]="newComment"
            [placeholder]="'requests.details.messageAreaPlaceholder' | translate">
        </textarea>

        <div *ngIf="toUploadDocuments.length > 0"
            class="attached-files-wrap d-flex flex-wrap justify-content-end mt-3"
        >
            <div *ngFor="let document of toUploadDocuments"
                class="attached-file-box d-flex align-items-center gap-1"
            >
                <span class="text-ellipsis"
                    textEllipsisToTooltip ngbTooltip="" tooltipClass="opacity-100"
                >
                    <span HJSuppress>{{document.documentName}}</span>
                </span>
                <button class="btn delete-x-btn" (click)="removeDocumentHandler(document)">
                    <i class="app-icon icon icon-sm icon-close"></i>
                </button>
            </div>

        </div>

        <div class="d-flex justify-content-end mt-4">
            <input
                type="file"
                class="input-file"
                [accept]="acceptExtensions"
                (change)="uploadFileInStoreHandler($event, UPLOAD_MODE.MANUAL)"
                id="message-document-uploader"
            />
            <label role="button" for="message-document-uploader"
                class="btn m-outline-btn me-3">
                <i class="app-icon icon icon-attach icon-xl"></i>
            </label>

            <button type="button" class="btn btn m-outline-btn me-3" (click)="openImageCaptureModal()">
                <i class="app-icon icon icon-image-take icon-xl"></i>
            </button>

            <button class="btn primary-btn"
                (click)="saveCommentHandler()"
                [disabled]="!newComment">
                {{'requests.details.sendMessage' | translate}}
            </button>
        </div>
    </div>
</div>
